import { Button } from "antd";
import React from "react";
import { useNewTrialState } from "../../../new-trail/hooks/NewTrialStateProvider";
import { AUTOZONE_REQUEST_STATUS } from "../../types";

interface DrawerAutozoneErrorProps {
  onClose?: () => void;
}

export const DrawerAutozoneError: React.FC<DrawerAutozoneErrorProps> = ({
  onClose,
}) => {
  const { setAutozoneRequestStatus } = useNewTrialState();
  const handleRetry = (): void => {
    setAutozoneRequestStatus(AUTOZONE_REQUEST_STATUS.RETRY);
  };
  return (
    <div className="drawer-autozone-error">
      <div className="error-content">
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.97 6C19.41 6 6 19.44 6 36C6 52.56 19.41 66 35.97 66C52.56 66 66 52.56 66 36C66 19.44 52.56 6 35.97 6ZM39 39V21H33V39H39ZM39 51V45H33V51H39ZM12 36C12 49.26 22.74 60 36 60C49.26 60 60 49.26 60 36C60 22.74 49.26 12 36 12C22.74 12 12 22.74 12 36Z"
            fill="#EB4B4B"
          />
        </svg>

        <h3>Error while generating autozones</h3>
        <p>It seems that we are having some issue to process this field</p>

        <div>
          <Button className="save-btn" size="large" onClick={handleRetry}>
            Try Again
          </Button>
          {onClose && (
            <Button
              className="draft-btn"
              size="large"
              onClick={() => {
                onClose();
              }}
              data-testid="save-btn"
            >
              Close
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
